import React from 'react';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  FormHelperText,
} from '@mui/material';

const ReusableFormikCheckbox = ({
  name,
  label,
  description,
  icon,
  isChecked,
  setIsChecked,
  formikSetField,
  formikError,
  children,
  classes,
}) => {
  const handleChange = (event) => {
    const value = event.target.checked;
    if (setIsChecked) setIsChecked(value);
    if (formikSetField) formikSetField(name, value);
  };

  return (
    <div className={classes.checkboxItemWrapper}>
      <div className={classes.checkboxIconContainer}>
          <Checkbox
            name={name}
            id={name}
            data-testid={name}
            checked={!!isChecked}
            onChange={handleChange}
            className={classes.checkbox}
          />
          <div className={classes.icon}>
            {icon}
          </div>
        </div>
      <Grid className={classes.descriptionAfter} size={12}>
        <label htmlFor={name} className={classes.descriptionLabel}>
          {label}
        </label>

        {description && (
          <label htmlFor={name} className={classes.description}>
            {description}
          </label>
        )}

        {formikError && (
          <FormHelperText component='span' error>
            {formikError}
          </FormHelperText>
        )}

        {children && <div className={classes.childrenWrapper}>{children}</div>}
      </Grid>
    </div>
  );
};

export default ReusableFormikCheckbox;
